import React from 'react';

export default function TeamLeadPurchaseLimit() {
    // Message for self-served Teams if they have lead purchase limitations
    let leadPurchaseMessage = null;

    if (window.teamIsSelfServed && window.teamLeadPurchaseLimit >= 0) {
        const count = window.teamLeadPurchaseLimit;
        const leads = window.teamLeadPurchaseLimit > 1 ? 'leads' : 'lead';

        if (count > 0) {
            leadPurchaseMessage = (
                <div className="tw-inline-block tw-border tw-border-[#c26b00] tw-bg-[#ffefc6] tw-rounded-md tw-py-2 tw-px-6">
                    <p className="tw-font-sans tw-text-[#c26b00]">
                        You are able to accept <strong>{count} more {leads}</strong> before your first invoice has been settled
                    </p>
                </div>
            );
        } else {
            leadPurchaseMessage = (
                <div className="tw-inline-block tw-border tw-border-[#c26b00] tw-bg-[#ffefc6] tw-rounded-md tw-py-2 tw-px-6">
                    <p className="tw-font-sans tw-text-[#c26b00]">
                        You are unable to accept any more leads until your first invoice has been settled
                    </p>
                </div>
            );
        }
    }

    return leadPurchaseMessage;
}
